import React, { useCallback, useEffect, useState } from 'react';
import { IconButton } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useSearchParams } from 'react-router-dom';

export const NavigationButtons = React.memo(({
cardId,
cardsOfSameWorkflowStepId,
}) => {

  const [currentCardIndex, setCurrentCardIndex] = useState(null);
    const [searchParams, setSearchParams] = useSearchParams();
  
    useEffect(() => {
      if (cardId && cardsOfSameWorkflowStepId.length > 0) {
        const index = cardsOfSameWorkflowStepId.findIndex(
          (item) => item.card.card_id == cardId
        );
        setCurrentCardIndex(index !== -1 ? index : null);
      }
    }, [cardId, cardsOfSameWorkflowStepId]);
  
    const updateSearchParams = useCallback((key, value) => {
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.set(key, value);
      setSearchParams(newSearchParams);
    }, [searchParams, setSearchParams]);
  
    const handlePrevious = useCallback(() => {
      if (currentCardIndex > 0) {
        const newIndex = currentCardIndex - 1;
        const newCardId = cardsOfSameWorkflowStepId[newIndex]?.card.card_id;
        // If the URL contains '/board/', change the route to boardkey-cardId, else just update search params
        const currentPath = window.location.pathname;
        if (currentPath.includes('/board/')) {
          // Extract the board key from the URL (assuming /board/:boardKey)
          const pathParts = currentPath.split('/');
          const boardIndex = pathParts.findIndex(part => part === 'board');
          const boardKey = pathParts[boardIndex + 1];
          if (boardKey && newCardId) {
            window.location.href = `/board/${boardKey}/${boardKey}-${newCardId}`;
          }
        } else {
          updateSearchParams("card_id", newCardId);
        }
        setCurrentCardIndex(newIndex);
      }
    }, [currentCardIndex, cardsOfSameWorkflowStepId, updateSearchParams]);
  
    const handleNext = useCallback(() => {
      if (currentCardIndex < cardsOfSameWorkflowStepId.length - 1) {
        const newIndex = currentCardIndex + 1;
        const newCardId = cardsOfSameWorkflowStepId[newIndex]?.card.card_id;
        // If the URL contains '/board/', change the route to boardkey-cardId, else just update search params
        const currentPath = window.location.pathname;
        if (currentPath.includes('/board/')) {
          // Extract the board key from the URL (assuming /board/:boardKey)
          const pathParts = currentPath.split('/');
          const boardIndex = pathParts.findIndex(part => part === 'board');
          const boardKey = pathParts[boardIndex + 1];
          if (boardKey && newCardId) {
            window.location.href = `/board/${boardKey}/${boardKey}-${newCardId}`;
          }
        } else {
          updateSearchParams("card_id", newCardId);
        }
        setCurrentCardIndex(newIndex);
      }
    }, [currentCardIndex, cardsOfSameWorkflowStepId, updateSearchParams]);
  
  return (
    <>
      {currentCardIndex > 0 && (
        <IconButton
          className="card-detail-prev-icon"
          onClick={handlePrevious}
          sx={{
            position: 'absolute',
            left: 16,
            bottom: '50%',
            padding: '12px',
            backgroundColor: '#DCDCDC',
            borderRadius: '50%',
            zIndex: 1000,
            transition: 'all 0.3s',
            '&:hover': {
              transform: 'scale(1.1)',
            },
          }}
        >
          <ArrowBackIosNewIcon />
        </IconButton>
      )}
      {currentCardIndex < cardsOfSameWorkflowStepId?.length - 1 && (
        <IconButton
          className="card-detail-next-icon"
          onClick={handleNext}
          sx={{
            position: 'absolute',
            right: 16,
            bottom: '50%',
            padding: '12px',
            backgroundColor: '#DCDCDC',
            borderRadius: '50%',
            zIndex: 1000,
            transition: 'all 0.3s',
            '&:hover': {
              transform: 'scale(1.1)',
            },
          }}
        >
          <ArrowForwardIosIcon />
        </IconButton>
      )}
    </>
  );
});